import React from "react";
import { Table } from "semantic-ui-react";
import FilaActividadesAsignadas from "./tablaActividadesAsignadas/FilaActividadesAsignadas";

function TablaActividadesAsignadas({ datos, handleRowClick }) {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Fecha Inicio</Table.HeaderCell>
          <Table.HeaderCell>Fecha Fin</Table.HeaderCell>
          <Table.HeaderCell>Actividad</Table.HeaderCell>
          <Table.HeaderCell>Importe</Table.HeaderCell>
          <Table.HeaderCell>Incremento No AMPA</Table.HeaderCell>
          <Table.HeaderCell>Incremento No Colegio</Table.HeaderCell>
          <Table.HeaderCell>Descuento</Table.HeaderCell>
          <Table.HeaderCell>Alumnos</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {datos.map(rowData => (
          <FilaActividadesAsignadas
            key={rowData.id}
            {...rowData}
            handleRowClick={handleRowClick}
          />
        ))}
      </Table.Body>
    </Table>
  );
}

export default TablaActividadesAsignadas;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/asignacionActividades/TablaActividadesAsignadas.jsx